var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2412 12.1182C28.1504 12.1182 28.0596 12.1269 27.9689 12.1385C26.2184 7.93273 22.4087 5.01074 18 5.01074C13.5913 5.01074 9.78164 7.93273 8.02853 12.1385C7.94035 12.1269 7.84958 12.1182 7.75622 12.1182C6.514 12.1182 5.5 13.251 5.5 14.6452V20.0157C5.5 21.407 6.51141 22.5427 7.75622 22.5427C9.00104 22.5427 10.0124 21.4099 10.0124 20.0157V14.6452C10.0124 13.8813 9.70902 13.1987 9.22925 12.7369C10.7775 9.04228 14.1255 6.48045 18 6.48045C21.8745 6.48045 25.2225 9.04228 26.7707 12.7311C26.291 13.1958 25.9876 13.8784 25.9876 14.6423V20.0128C25.9876 20.7767 26.2936 21.4593 26.7707 21.924C25.4715 25.0232 22.8989 27.3236 19.8128 27.9829C19.5223 27.1784 18.8195 26.6091 18 26.6091C16.9212 26.6091 16.0446 27.5908 16.0446 28.7991C16.0446 30.0074 16.9212 30.9892 18 30.9892C18.8714 30.9892 19.6105 30.3473 19.862 29.4672C23.4616 28.7759 26.4699 26.1211 27.9715 22.5195C28.0596 22.5311 28.1504 22.5398 28.2438 22.5398C29.486 22.5398 30.5 21.407 30.5 20.0128V14.6423C30.5 13.251 29.4886 12.1153 28.2438 12.1153L28.2412 12.1182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCall);
export default __webpack_public_path__ + "static/media/icon_call.a3c8cf38dd9531e77142d836fafda91c.svg";
export { ForwardRef as ReactComponent };